import React from 'react';

import { makeStyles, Theme } from '@material-ui/core';

import { ProfileActionsType } from '../../../../types/menu';
import * as Api from '../../../../weborder/Api';
import { Typography } from '../../../atoms';
import { Drawer } from '../../../layouts';
import { ProfileList } from './ProfileList';

const useStyles = makeStyles((theme: Theme) => ({
  drawerHeader: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(2),
  },
}));

type ProfileDrawerProps = {
  configData: Api.AppConfig;
  contactFormType: Api.ContactFormType;
  customerData: Api.Customer;
  customerProfileActions: ProfileActionsType;
  hasDisableNonEssentialCookies: boolean;
  hasGdprCookieFeatureFlag: boolean;
  languageCode: string;
  onCloseDrawer: () => void;
  onShowPaymentsDialog: () => void;
  showDrawer: boolean;
  translate: any;
};

export function ProfileDrawer(props: ProfileDrawerProps): JSX.Element {
  const {
    configData,
    contactFormType,
    customerData,
    customerProfileActions,
    hasDisableNonEssentialCookies,
    hasGdprCookieFeatureFlag,
    languageCode,
    onCloseDrawer,
    onShowPaymentsDialog,
    showDrawer,
    translate,
  } = props;

  const classes = useStyles();

  return (
    <Drawer open={showDrawer} onClose={onCloseDrawer}>
      <div className={classes.drawerHeader}>
        <Typography variant="h1">{translate('Menu_Profile_Title')}</Typography>
        <Typography variant="body2-secondary">
          {customerData.CustomerPhoneNumberLocalFormatString}
        </Typography>
      </div>
      <ProfileList
        actions={customerProfileActions}
        configData={configData}
        contactFormType={contactFormType}
        customerData={customerData}
        hasDisableNonEssentialCookies={hasDisableNonEssentialCookies}
        hasGdprCookieFeatureFlag={hasGdprCookieFeatureFlag}
        languageCode={languageCode}
        onOpenPayments={onShowPaymentsDialog}
        translate={translate}
      />
    </Drawer>
  );
}
